import { makeStyles } from "tss-react/mui";
import { Box, Typography, useTheme } from "@mui/material";
import { MiFieldSet } from "../MiFieldSet/MiFieldSet";

const useCardInfoStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  title: {
    color: theme.palette.primary.main,
    fontWeight: theme.fontWeight.bold,
    fontSize: 14,
  },
  rightContent: { flexShrink: 1 },
}));

/**
 * Component - CardInfo
 * @param {Object} props
 * @param {String} props.title
 * @param {Object[]} props.fields
 * @param {Function} props.renderLeftIcon
 * @param {Function} props.renderRightContent
 * @param {String?} props.className
 * @returns
 */
export function CardInfo({
  title,
  fields = [],
  renderLeftIcon,
  renderRightContent,
  item,
}) {
  const theme = useTheme();
  const { classes } = useCardInfoStyles();
  const leftIcon = renderLeftIcon?.();

  return (
    <Box className={classes.container} gap={leftIcon ? theme.spacing(1) : 0}>
      <Box>{leftIcon}</Box>
      <Box className={classes.textContainer}>
        {typeof title === "string" ? (
          <Typography className={classes.title}>{title}</Typography>
        ) : (
          title
        )}
        <MiFieldSet
          hasDivider
          compact
          labelStyle={{
            color: theme.palette.grey[800],
            fontSize: theme.fontSize.small,
            textWrap: "nowrap",
            textOverflow: "ellipsis",
          }}
          containerStyle={{
            margin: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          fieldset={[...fields]}
          row={item}
        />
      </Box>
      <Box className={classes.rightContent}>{renderRightContent?.()}</Box>
    </Box>
  );
}
